var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "ad18a731-ed77-4085-88b7-419d3fe4f2f8",
    version: "0.0.15",
    organization: "taylor",
    project: "heroine",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/heroine",
    username: "taylor+taylor@haiku.ai",
    root: "https://cdn.haiku.ai/e062580c-8941-425f-9ce7-f01d8d3a6bef/07ee961d5f9b270810efecb4f5013685c38388c4/",
    core: "4.2.0",
    title: "Pink",
    type: "haiku",
    relpath: "code/pink/code.js"
  },
  options: {},
  states: {
    lift: { type: "number", value: 20, edited: true },
    finished: { type: "boolean", value: false, edited: true }
  },
  eventHandlers: {
    "haiku:Pink-280c7b78193c2617": {
      "timeline:Default:0": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      playPink: {
        handler: function(component, element, target, event) {
          let frame = this.state.finished ? 90 : 1;
          this.getDefaultTimeline().gotoAndPlay(frame);
        }
      },
      "timeline:Default:89": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      "timeline:Default:174": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      }
    },
    "haiku:Lg-0fab6c9df26a7d61": {}
  },
  timelines: {
    Default: {
      "haiku:Slot-e55832c974330c3d": {
        "style.position": "absolute",
        "sizeAbsolute.x": 55,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 89,
        "translation.y": 56.5,
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 52,
        "sizeMode.y": 1,
        "style.zIndex": 1,
        opacity: {
          "0": { value: 1, edited: true },
          "517": { value: 0, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        }
      },
      "haiku:Group-5e1312e5e9201c75": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.645926339,
        "translation.x": -34.508,
        "translation.y": -17.826
      },
      "haiku:Group-ddd97b8154ef9c3a": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -7,
        "translation.y": -5
      },
      "haiku:slot-6053fc281e36664d": {
        fill: "#1B2226",
        x: 7,
        y: 5,
        width: 55,
        height: 52,
        rx: 10
      },
      "haiku:Lg-0fab6c9df26a7d61": {
        "sizeMode.x": 1,
        "translation.y": 57.419,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 89.488,
        "style.position": "absolute",
        "sizeAbsolute.x": 39.9766731262207,
        "style.overflow": "visible",
        "sizeAbsolute.y": 41.83710861206055,
        "sizeMode.y": 1,
        "style.zIndex": 5,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2700": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-15387a51b38e1e18": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.645926339,
        "translation.x": -5,
        "translation.y": -6
      },
      "haiku:lg-4b8d4c03e328e81a": {
        fill: "#FF6EA8",
        points: "40 6 44.9766736 47.8371082 5 41"
      },
      "haiku:Wire-e879179afe68d38e": {
        "sizeMode.x": 1,
        "translation.y": 45.65,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 74.881,
        "style.position": "absolute",
        "sizeAbsolute.x": 14.8829345703125,
        "style.overflow": "visible",
        "sizeAbsolute.y": 22.065765380859375,
        "sizeMode.y": 1,
        "style.zIndex": 6,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift + 10;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "900": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "900": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1483": { value: 1, edited: true },
          "1883": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2300": { value: 1.4, edited: true, curve: "easeOutBack" },
          "3050": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "900": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1483": { value: 1, edited: true },
          "1883": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2300": { value: 1.4, edited: true, curve: "easeOutBack" },
          "3050": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1883": { value: 0, edited: true, curve: "easeOutCubic" },
          "3083": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-4901bdb3e67b69e9": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.645926339,
        "translation.x": -2.939,
        "translation.y": -4.117
      },
      "haiku:wire-d5e542c43e3abc08": {
        d:
          "M12.5350129,4.11737557 L2.93916687,14.5487812 L17.8221023,26.1831418 L12.5350129,4.11737557 Z",
        stroke: "#FF6EA8",
        strokeWidth: 4
      },
      "haiku:Sm-c6190f50e0890ee4": {
        "sizeAbsolute.x": 26.329792022705078,
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1700": { value: 0, edited: true, curve: "easeOutCubic" },
          "2900": { value: 6.28, edited: true }
        },
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 112.18,
        "translation.y": 61.332,
        "style.position": "absolute",
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 26.003183364868164,
        "sizeMode.y": 1,
        "style.zIndex": 7,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift + 15;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "717": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "717": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1700": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2117": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2867": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "717": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1700": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2117": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2867": { value: 1, edited: true }
        }
      },
      "haiku:Pink-280c7b78193c2617": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 177,
        "sizeAbsolute.y": 148,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:sm-c30dd2329fa3c0dc": {
        fill: "#FF6EA8",
        points:
          "44.913031 17.8257123 60.8376677 43.8288972 34.5078757 29.136898"
      },
      "haiku:Shad-Lg-b811b1d9c61ef636": {
        "sizeMode.x": 1,
        "translation.y": 71.419,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 79.488,
        "style.position": "absolute",
        "sizeAbsolute.x": 39.9766731262207,
        "style.overflow": "visible",
        "sizeAbsolute.y": 41.83710861206055,
        "sizeMode.y": 1,
        "style.zIndex": 2,
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2700": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-bee0207c54419ee4": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -5,
        "translation.y": -6
      },
      "haiku:shad_lg-42d3939e0226807f": {
        fill: "#1A2125",
        points: "40 6 44.9766736 47.8371082 5 41"
      },
      "haiku:Shad-Wire-2ecef42a5e7091cc": {
        "sizeMode.x": 1,
        "translation.y": 59.65,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 64.881,
        "style.position": "absolute",
        "sizeAbsolute.x": 14.8829345703125,
        "style.overflow": "visible",
        "sizeAbsolute.y": 22.065765380859375,
        "sizeMode.y": 1,
        "style.zIndex": 3,
        opacity: {
          "0": { value: 0, edited: true },
          "900": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "900": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1483": { value: 1, edited: true },
          "1883": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2300": { value: 1.4, edited: true, curve: "easeOutBack" },
          "3050": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "900": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1483": { value: 1, edited: true },
          "1883": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2300": { value: 1.4, edited: true, curve: "easeOutBack" },
          "3050": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1883": { value: 0, edited: true, curve: "easeOutCubic" },
          "3083": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-af09749ed5d3691d": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -2.939,
        "translation.y": -4.117
      },
      "haiku:shad_wire-7ce8e854850aa829": {
        d:
          "M12.5350129,4.11737557 L2.93916687,14.5487812 L17.8221023,26.1831418 L12.5350129,4.11737557 Z",
        stroke: "#1A2125",
        strokeWidth: 4
      },
      "haiku:Shad-Sm-4aa4552ee4287c3f": {
        "sizeAbsolute.x": 26.329792022705078,
        "translation.y": 75.332,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 102.18,
        "style.position": "absolute",
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1700": { value: 0, edited: true, curve: "easeOutCubic" },
          "2900": { value: 6.28, edited: true }
        },
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 26.003183364868164,
        "sizeMode.y": 1,
        "style.zIndex": 4,
        opacity: {
          "0": { value: 0, edited: true },
          "717": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "717": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1700": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2117": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2867": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "717": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1700": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2117": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2867": { value: 1, edited: true }
        }
      },
      "haiku:Group-4af9caab1b1b7e6d": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -34.508,
        "translation.y": -17.826
      },
      "haiku:shad_sm-490833b7acbbd459": {
        fill: "#1A2125",
        points:
          "44.913031 17.8257123 60.8376677 43.8288972 34.5078757 29.136898"
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Pink-280c7b78193c2617", "haiku-title": "Pink" },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Sm-4aa4552ee4287c3f",
          "haiku-title": "shad_sm",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_pink.svg#shadow#shad_sm"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-4af9caab1b1b7e6d" },
            children: [
              {
                elementName: "polygon",
                attributes: {
                  "haiku-id": "shad_sm-490833b7acbbd459",
                  id: "shad_sm"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Wire-2ecef42a5e7091cc",
          "haiku-title": "shad_wire",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_pink.svg#shadow#shad_wire"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-af09749ed5d3691d" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "shad_wire-7ce8e854850aa829",
                  id: "shad_wire"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Lg-b811b1d9c61ef636",
          "haiku-title": "shad_lg",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_pink.svg#shadow#shad_lg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-bee0207c54419ee4" },
            children: [
              {
                elementName: "polygon",
                attributes: {
                  "haiku-id": "shad_lg-42d3939e0226807f",
                  id: "shad_lg"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Sm-c6190f50e0890ee4",
          "haiku-title": "sm",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_pink.svg#thing#sm"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-5e1312e5e9201c75" },
            children: [
              {
                elementName: "polygon",
                attributes: { "haiku-id": "sm-c30dd2329fa3c0dc", id: "sm" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Wire-e879179afe68d38e",
          "haiku-title": "wire",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_pink.svg#thing#wire"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-4901bdb3e67b69e9" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "wire-d5e542c43e3abc08", id: "wire" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Lg-0fab6c9df26a7d61",
          "haiku-title": "lg",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_pink.svg#thing#lg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-15387a51b38e1e18" },
            children: [
              {
                elementName: "polygon",
                attributes: { "haiku-id": "lg-4b8d4c03e328e81a", id: "lg" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Slot-e55832c974330c3d",
          "haiku-title": "slot",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_pink.svg#slot"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-ddd97b8154ef9c3a" },
            children: [
              {
                elementName: "rect",
                attributes: { "haiku-id": "slot-6053fc281e36664d", id: "slot" },
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-heroine/code/pink/code.js
// module id = 525
// module chunks = 35783957827783